<template>
<el-descriptions class="margin-top" title="发票明细" :column="3" :size="size" border>
    <template slot="extra">
      <el-button type="primary" size="small">操作</el-button>
    </template>
    <el-descriptions-item label="日期">{{form.invoice_date}}</el-descriptions-item>
    <el-descriptions-item label="发票抬头">{{form.company_name}}</el-descriptions-item>
    <el-descriptions-item label="税号">{{form.company_taxId}}</el-descriptions-item>
    <el-descriptions-item label="发票号码">
      <el-tag size="normal">{{form.invoiceId}}</el-tag>
    </el-descriptions-item>
    <el-descriptions-item label="收件人">{{form.shipName}}</el-descriptions-item>
	<el-descriptions-item label="收件人电话">{{form.shipTel}}</el-descriptions-item>
	<el-descriptions-item label="收件人地址">{{form.shipAddress}}</el-descriptions-item>
	<el-descriptions-item label="备注">{{form.remark}}</el-descriptions-item>
  </el-descriptions>
</template>
 
<script>
export default {
    data() {
      return {
	    is_loading: false,
		loading: true,
		size: '',
        form: {
          invoice_date: '',
		  company_name: '',
		  company_taxId: '',
		  invoiceId: '', 
		  shipName: '',
		  shipTel: '',
		  shipAddress: '',
		  remark: '',
        }
      }
    },

    methods: {
	  getInfo(){
 
	    let that = this; 
		let info = {};
		let id =  localStorage.getItem('invoiceId'); 		
		if (id != undefined && id != 0)
		    info.id = id;
		let order_id =  localStorage.getItem('orderId'); 		
		if (order_id != undefined && order_id != 0 )
		    info.order_id = order_id;			
			
        console.log( 'id:' + id);  
		  $.ajax({
              type: "GET",
			  data:  info,
              url: "https://www.myferp.com/admin/user/invoiceDetail",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.loading = false;
			      Vue.prototype.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        
				console.log(JSON.stringify(data));
				that.form.invoice_date = data.data.invoice_date;
                that.form.company_name = data.data.company_name;
                that.form.company_taxId = data.data.company_taxId;
				that.form.invoiceId = data.data.invoiceId; 	
                that.form.shipName = data.data.shipName;
                that.form.shipTel = data.data.shipTel;
				that.form.shipAddress = data.data.shipAddress; 					
				that.form.remark = data.data.remark; 	
				
                that.loading = false;				
                }
              });	
	  },
	  
      onSubmit() { 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		that.is_loading = true;
        console.log(that.form.birthday);  
		  $.ajax({
              type: "POST",
			  data: {id: info.id, 
			      nickname: that.form.name, 
				  tel: that.form.tel, 
				  email: that.form.email,
				  birthday: that.form.birthday,
				  gender: that.form.gender,
				  company: that.form.company} ,
              url: "https://www.myferp.com/admin/user/updateInfo",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.is_loading = false;
			      Vue.prototype.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        that.is_loading = false;
				console.log(JSON.stringify(data));
				Vue.prototype.$message({
                  message: data,
                  type: 'success'
                  });
                }
              });	
			 
			     
      }
    },
    mounted() {
      this.getInfo();	
	},
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/invoiceDetail.vue